import _regeneratorRuntime from "@babel/runtime/regenerator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { get, has, set } from "lodash";
import { Locales } from "./Locales";
import { Pluralization } from "./Pluralization";
import { MissingTranslation } from "./MissingTranslation";
import { camelCaseKeys, createTranslationOptions, formatNumber, inferType, interpolate, isSet, lookup, numberToDelimited as _numberToDelimited, numberToHuman as _numberToHuman, numberToHumanSize as _numberToHumanSize, parseDate, pluralize as _pluralize, propertyFlatList, strftime as _strftime, timeAgoInWords as _timeAgoInWords } from "./helpers";
var DEFAULT_I18N_OPTIONS = {
  defaultLocale: "en",
  locale: "en",
  defaultSeparator: ".",
  placeholder: /(?:\{\{|%\{)(.*?)(?:\}\}?)/gm,
  enableFallback: false,
  missingBehavior: "message",
  missingTranslationPrefix: "",
  missingPlaceholder: function missingPlaceholder(_i18n, placeholder) {
    return "[missing \"".concat(placeholder, "\" value]");
  },
  nullPlaceholder: function nullPlaceholder(i18n, placeholder, message, options) {
    return i18n.missingPlaceholder(i18n, placeholder, message, options);
  },
  transformKey: function transformKey(key) {
    return key;
  }
};
export var I18n = /*#__PURE__*/function () {
  function I18n() {
    var translations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, I18n);

    this._locale = DEFAULT_I18N_OPTIONS.locale;
    this._defaultLocale = DEFAULT_I18N_OPTIONS.defaultLocale;
    this._version = 0;
    this.onChangeHandlers = [];
    this.translations = {};
    this.t = this.translate;
    this.p = this.pluralize;
    this.l = this.localize;
    this.distanceOfTimeInWords = this.timeAgoInWords;

    var _Object$assign = Object.assign(Object.assign({}, DEFAULT_I18N_OPTIONS), options),
        locale = _Object$assign.locale,
        enableFallback = _Object$assign.enableFallback,
        missingBehavior = _Object$assign.missingBehavior,
        missingTranslationPrefix = _Object$assign.missingTranslationPrefix,
        missingPlaceholder = _Object$assign.missingPlaceholder,
        nullPlaceholder = _Object$assign.nullPlaceholder,
        defaultLocale = _Object$assign.defaultLocale,
        defaultSeparator = _Object$assign.defaultSeparator,
        placeholder = _Object$assign.placeholder,
        transformKey = _Object$assign.transformKey;

    this.locale = locale;
    this.defaultLocale = defaultLocale;
    this.defaultSeparator = defaultSeparator;
    this.enableFallback = enableFallback;
    this.locale = locale;
    this.missingBehavior = missingBehavior;
    this.missingTranslationPrefix = missingTranslationPrefix;
    this.missingPlaceholder = missingPlaceholder;
    this.nullPlaceholder = nullPlaceholder;
    this.placeholder = placeholder;
    this.pluralization = new Pluralization(this);
    this.locales = new Locales(this);
    this.missingTranslation = new MissingTranslation(this);
    this.transformKey = transformKey;
    this.interpolate = interpolate;
    this.store(translations);
  }

  _createClass(I18n, [{
    key: "store",
    value: function store(translations) {
      var _this = this;

      var map = propertyFlatList(translations);
      map.forEach(function (path) {
        return set(_this.translations, path, get(translations, path));
      });
      this.hasChanged();
    }
  }, {
    key: "locale",
    get: function get() {
      return this._locale || this.defaultLocale || "en";
    },
    set: function set(newLocale) {
      if (typeof newLocale !== "string") {
        throw new Error("Expected newLocale to be a string; got ".concat(inferType(newLocale)));
      }

      var changed = this._locale !== newLocale;
      this._locale = newLocale;

      if (changed) {
        this.hasChanged();
      }
    }
  }, {
    key: "defaultLocale",
    get: function get() {
      return this._defaultLocale || "en";
    },
    set: function set(newLocale) {
      if (typeof newLocale !== "string") {
        throw new Error("Expected newLocale to be a string; got ".concat(inferType(newLocale)));
      }

      var changed = this._defaultLocale !== newLocale;
      this._defaultLocale = newLocale;

      if (changed) {
        this.hasChanged();
      }
    }
  }, {
    key: "translate",
    value: function translate(scope, options) {
      var _this2 = this;

      options = Object.assign({}, options);
      var translationOptions = createTranslationOptions(this, scope, options);
      var translation;
      var hasFoundTranslation = translationOptions.some(function (translationOption) {
        if (isSet(translationOption.scope)) {
          translation = lookup(_this2, translationOption.scope, options);
        } else if (isSet(translationOption.message)) {
          translation = translationOption.message;
        }

        return translation !== undefined && translation !== null;
      });

      if (!hasFoundTranslation) {
        return this.missingTranslation.get(scope, options);
      }

      if (typeof translation === "string") {
        translation = this.interpolate(this, translation, options);
      } else if (_typeof(translation) === "object" && translation && isSet(options.count)) {
        translation = this.pluralize(options.count || 0, translation, options);
      }

      return translation;
    }
  }, {
    key: "pluralize",
    value: function pluralize(count, scope, options) {
      return _pluralize(this, count, scope, Object.assign({}, options));
    }
  }, {
    key: "localize",
    value: function localize(type, value, options) {
      options = Object.assign({}, options);

      if (value === undefined || value === null) {
        return "";
      }

      switch (type) {
        case "currency":
          return this.numberToCurrency(value);

        case "number":
          return formatNumber(value, Object.assign({
            delimiter: ",",
            precision: 3,
            separator: ".",
            significant: false,
            stripInsignificantZeros: false
          }, lookup(this, "number.format")));

        case "percentage":
          return this.numberToPercentage(value);

        default:
          {
            var localizedValue;

            if (type.match(/^(date|time)/)) {
              localizedValue = this.toTime(type, value);
            } else {
              localizedValue = value.toString();
            }

            return interpolate(this, localizedValue, options);
          }
      }
    }
  }, {
    key: "toTime",
    value: function toTime(scope, input) {
      var date = parseDate(input);
      var format = lookup(this, scope);

      if (date.toString().match(/invalid/i)) {
        return date.toString();
      }

      if (!format) {
        return date.toString();
      }

      return this.strftime(date, format);
    }
  }, {
    key: "numberToCurrency",
    value: function numberToCurrency(input) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return formatNumber(input, Object.assign(Object.assign(Object.assign({
        delimiter: ",",
        format: "%u%n",
        precision: 2,
        separator: ".",
        significant: false,
        stripInsignificantZeros: false,
        unit: "$"
      }, camelCaseKeys(this.get("number.format"))), camelCaseKeys(this.get("number.currency.format"))), options));
    }
  }, {
    key: "numberToPercentage",
    value: function numberToPercentage(input) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return formatNumber(input, Object.assign(Object.assign(Object.assign({
        delimiter: "",
        format: "%n%",
        precision: 3,
        stripInsignificantZeros: false,
        separator: ".",
        significant: false
      }, camelCaseKeys(this.get("number.format"))), camelCaseKeys(this.get("number.percentage.format"))), options));
    }
  }, {
    key: "numberToHumanSize",
    value: function numberToHumanSize(input) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _numberToHumanSize(this, input, Object.assign(Object.assign(Object.assign({
        delimiter: "",
        precision: 3,
        significant: true,
        stripInsignificantZeros: true,
        units: {
          billion: "Billion",
          million: "Million",
          quadrillion: "Quadrillion",
          thousand: "Thousand",
          trillion: "Trillion",
          unit: ""
        }
      }, camelCaseKeys(this.get("number.human.format"))), camelCaseKeys(this.get("number.human.storage_units"))), options));
    }
  }, {
    key: "numberToHuman",
    value: function numberToHuman(input) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _numberToHuman(this, input, Object.assign(Object.assign(Object.assign({
        delimiter: "",
        separator: ".",
        precision: 3,
        significant: true,
        stripInsignificantZeros: true,
        format: "%n %u",
        roundMode: "default",
        units: {
          billion: "Billion",
          million: "Million",
          quadrillion: "Quadrillion",
          thousand: "Thousand",
          trillion: "Trillion",
          unit: ""
        }
      }, camelCaseKeys(this.get("number.human.format"))), camelCaseKeys(this.get("number.human.decimal_units"))), options));
    }
  }, {
    key: "numberToRounded",
    value: function numberToRounded(input, options) {
      return formatNumber(input, Object.assign({
        unit: "",
        precision: 3,
        significant: false,
        separator: ".",
        delimiter: "",
        stripInsignificantZeros: false
      }, options));
    }
  }, {
    key: "numberToDelimited",
    value: function numberToDelimited(input) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _numberToDelimited(input, Object.assign({
        delimiterPattern: /(\d)(?=(\d\d\d)+(?!\d))/g,
        delimiter: ",",
        separator: "."
      }, options));
    }
  }, {
    key: "withLocale",
    value: function withLocale(locale, callback) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var originalLocale;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                originalLocale = this.locale;
                _context.prev = 1;
                this.locale = locale;
                _context.next = 5;
                return callback();

              case 5:
                _context.prev = 5;
                this.locale = originalLocale;
                return _context.finish(5);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1,, 5, 8]]);
      }));
    }
  }, {
    key: "strftime",
    value: function strftime(date, format) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return _strftime(date, format, Object.assign(Object.assign(Object.assign({}, camelCaseKeys(lookup(this, "date"))), {
        meridian: {
          am: lookup(this, "time.am") || "AM",
          pm: lookup(this, "time.pm") || "PM"
        }
      }), options));
    }
  }, {
    key: "update",
    value: function update(path, override) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        strict: false
      };

      if (options.strict && !has(this.translations, path)) {
        throw new Error("The path \"".concat(path, "\" is not currently defined"));
      }

      var currentNode = get(this.translations, path);
      var currentType = inferType(currentNode);
      var overrideType = inferType(override);

      if (options.strict && currentType !== overrideType) {
        throw new Error("The current type for \"".concat(path, "\" is \"").concat(currentType, "\", but you're trying to override it with \"").concat(overrideType, "\""));
      }

      var newNode;

      if (overrideType === "object") {
        newNode = Object.assign(Object.assign({}, currentNode), override);
      } else {
        newNode = override;
      }

      set(this.translations, path, newNode);
      this.hasChanged();
    }
  }, {
    key: "toSentence",
    value: function toSentence(items) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _Object$assign2 = Object.assign(Object.assign({
        wordsConnector: ", ",
        twoWordsConnector: " and ",
        lastWordConnector: ", and "
      }, camelCaseKeys(lookup(this, "support.array"))), options),
          wordsConnector = _Object$assign2.wordsConnector,
          twoWordsConnector = _Object$assign2.twoWordsConnector,
          lastWordConnector = _Object$assign2.lastWordConnector;

      var size = items.length;

      switch (size) {
        case 0:
          return "";

        case 1:
          return "".concat(items[0]);

        case 2:
          return items.join(twoWordsConnector);

        default:
          return [items.slice(0, size - 1).join(wordsConnector), lastWordConnector, items[size - 1]].join("");
      }
    }
  }, {
    key: "timeAgoInWords",
    value: function timeAgoInWords(fromTime, toTime) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return _timeAgoInWords(this, fromTime, toTime, options);
    }
  }, {
    key: "onChange",
    value: function onChange(callback) {
      var _this3 = this;

      this.onChangeHandlers.push(callback);
      return function () {
        _this3.onChangeHandlers.splice(_this3.onChangeHandlers.indexOf(callback), 1);
      };
    }
  }, {
    key: "version",
    get: function get() {
      return this._version;
    }
  }, {
    key: "get",
    value: function get(scope) {
      return lookup(this, scope);
    }
  }, {
    key: "runCallbacks",
    value: function runCallbacks() {
      var _this4 = this;

      this.onChangeHandlers.forEach(function (callback) {
        return callback(_this4);
      });
    }
  }, {
    key: "hasChanged",
    value: function hasChanged() {
      this._version += 1;
      this.runCallbacks();
    }
  }]);

  return I18n;
}();